import React from 'react';
import { flexRender } from '@tanstack/react-table';

import { BodyProps } from './types';

export const Body: React.FC<BodyProps> = ({ rowModel, emptyText }) => {
    return (
        <tbody>
            {rowModel.rows && rowModel.rows.length === 0 && (
                <tr>
                    <td colSpan={100}>{emptyText ? emptyText : 'No records.'}</td>
                </tr>
            )}
            {rowModel.rows &&
                rowModel.rows.length > 0 &&
                rowModel.rows.map((row, index) => {
                    return (
                        <tr key={`${index}_${row.id}`}>
                            {row.getVisibleCells().map((cell, index) => {
                                return <td key={`${index}_${cell.id}`}> {flexRender(cell.column.columnDef.cell, cell.getContext())}</td>;
                            })}
                        </tr>
                    );
                })}
        </tbody>
    );
};

export default Body;
